import { render, staticRenderFns } from "./alTableBtns.vue?vue&type=template&id=97d2f3e0&scoped=true&"
import script from "./alTableBtns.vue?vue&type=script&lang=js&"
export * from "./alTableBtns.vue?vue&type=script&lang=js&"
import style0 from "./alTableBtns.vue?vue&type=style&index=0&id=97d2f3e0&prod&scoped=true&lang=less&"
import style1 from "./alTableBtns.vue?vue&type=style&index=1&id=97d2f3e0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d2f3e0",
  null
  
)

export default component.exports